import React,{useState,useEffect} from "react";
import BrandAll from '../components/BrandAll'
import CategoryCard from '../components/CategoryCard'
import { useDispatch, useSelector } from "react-redux";
import { featchCarData, getlatestCar } from "../Redux/Slice/DataSlice";



const Category = () => {
  const {latestCar,Brands,Categories,status}=useSelector((state)=>state.CarData)

  const dispatch=useDispatch()

  useEffect(() => {

    dispatch(featchCarData()).then(()=>{
      dispatch(getlatestCar())
    })
 
  }, []);
  return (
    <div className="w-[100%]">
{  
      status==="pending" ?
 
<div id="app-preloader">
  <svg
              className="fill-current h-8 mr-2 w-8 preloader-logo"
              xmlns="http://www.w3.org/2000/svg"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-miterlimit="1.5"
              clip-rule="evenodd"
              viewBox="0 0 716 895"
            >
              <path d="M357.776 0l357.77 178.885v536.657l-357.77 178.89L0 715.542V178.885"></path>
              <path
                className="text-white fill-current"
                d="M357.776 804.982l268.32-134.16v-178.89l-89.44-44.72 89.44-44.72V223.606L357.776 89.442v626.1l-178.89-89.44V178.885l-89.443 44.721v447.216l268.333 134.16z"
              ></path>
              <path d="M447.216 670.822l89.44-44.72v-89.45l-89.44-44.72v178.89zM447.216 402.492l89.44-44.721v-89.443l-89.44-44.722"></path>
            </svg>
	<div class="preloader-title"></div>
	<div class="preloader-spinner">
		<svg class="preloader-spinner-icon" viewBox="0 0 24 24">
			<path d="M 22.49772,12.000001 A 10.49772,10.497721 0 0 1 12,22.497722 10.49772,10.497721 0 0 1 1.5022797,12.000001 10.49772,10.497721 0 0 1 12,1.5022797 10.49772,10.497721 0 0 1 22.49772,12.000001 Z" fill="none" stroke-linecap="round" />
		</svg>
	</div>
</div>
    
    
    :

    <div className="w-[100%]">
<div class="w-[100%] flex justify-center items-center">
<div className="w-[100%] flex justify-center items-center flex-wrap sm:flex-row flex-col ">

{
  Categories && Categories.map((x)=>{
    return(
      <CategoryCard x={x} key={x.id}/>
    )

  })
}


</div>
</div>

<div className=" w-[100%] flex justify-center items-start gap-2 flex-col sm:flex-row  mt-10 mb-10">

 {
  Brands && Brands.map((x, index) => {
                      return(

                 <BrandAll Brand={x} key={index}/>

                 )
                })
      }
  

</div>
    
    
    </div>
    }
    </div>
  )
}

export default Category